import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {map} from 'rxjs/operators';
import {IIndicador} from '../models/indicadores.model';

const indicadores: IIndicador[] = [
  {id: 0, nome: 'receita_faturamento', caption: 'Receita / Faturamento'},
  {id: 1, nome: 'vendas_feitas', caption: 'Vendas Feitas'},
  {id: 2, nome: 'ticket_medio', caption: 'Ticket Médio'},
  {id: 3, nome: 'preco_medio', caption: 'Preço Médio'},
  {id: 4, nome: 'itens_venda', caption: 'Itens por Venda (PA)'},
  {id: 5, nome: 'itens_vendidos', caption: 'Itens Vendidos'},
  {id: 6, nome: 'desconto', caption: 'Desconto'}
];

@Injectable()
export class IndicadoresService {

  getIndicadores(): Observable<IIndicador[]> {
    return Observable.from(indicadores)
      .pipe(map(data => {
        return <IIndicador>data;
      }))
      .toArray();
  }
}
